import { Modal } from "@asurion-core/aui-react-modal";
import { Action, Text } from "@asurion-core/mx-asurion-ui-react";
import { showSBApiErrorModal, useGlobalDispatch } from "@ubif/util-store";
import { useTranslation } from "react-i18next";

type SBApiErrorsModalProps = {
  id?: string;
  errorMessage: string;
};

export const SBApiErrorsModal = ({ id, errorMessage }: SBApiErrorsModalProps) => {
  const { t } = useTranslation("root-config");
  const globalDispatch = useGlobalDispatch();

  const onClose = () => {
    globalDispatch(
      showSBApiErrorModal({
        id: id,
        errorMessage: ""
      })
    );
  };

  return (
    <Modal isOpen={!!errorMessage?.length} onCloseModal={onClose} style={{ minHeight: "fit-content" }}>
      <Modal.Header>
        <Modal.Title>{errorMessage}</Modal.Title>
      </Modal.Header>
      <Modal.Content>
        <Text>{t("PleaseContactHelpDeskForSupport", "Please contact Help Desk for support.")}</Text>
      </Modal.Content>
      <Modal.Footer>
        <Action variant="outline" onClick={onClose}>
          {t("Close", "Close")}
        </Action>
      </Modal.Footer>
    </Modal>
  );
};
